import AccountBalanceWalletOutlinedIcon from '@mui/icons-material/AccountBalanceWalletOutlined';
import AssignmentOutlinedIcon from '@mui/icons-material/AssignmentOutlined';
import AutoFixHighOutlinedIcon from '@mui/icons-material/AutoFixHighOutlined';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import DashboardOutlinedIcon from '@mui/icons-material/DashboardOutlined';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import FileCopyOutlinedIcon from '@mui/icons-material/FileCopyOutlined';
import ReceiptLongOutlinedIcon from '@mui/icons-material/ReceiptLongOutlined';
import StackedBarChartOutlinedIcon from '@mui/icons-material/StackedBarChartOutlined';
import TuneOutlinedIcon from '@mui/icons-material/TuneOutlined';
import WorkOutlineOutlinedIcon from '@mui/icons-material/WorkOutlineOutlined';
import { INTERNAL_DOCUMENT_TYPE } from 'features/internal-document/common/types';
import { WORK_TYPE } from 'features/work/types';
import { MENU_ITEM_CODE } from 'layouts/MainLayout/contants';
import { renderSidebarLabel } from 'layouts/MainLayout/helper';
import { ReactNode } from 'react';
import { getPath } from 'routes/router-paths';
import { WORK_SCHEDULE_URL } from 'routes/types';
import { v4 as uuid } from 'uuid';

export enum MODULE_KEY {
  CALENDAR = 'CALENDAR',
  DOCUMENT = 'DOCUMENT',
  MISSION = 'MISSION',
  WORK = 'WORK',
  SALARY = 'SALARY',
  PROPOSAL = 'PROPOSAL',
  RISK = 'RISK',
  UTILITY = 'UTILITY',
  ADMIN_SYSTEM = 'ADMIN_SYSTEM',
}

export type MenuItem = {
  key: string;
  label: ReactNode;
  code: MENU_ITEM_CODE;
  icon?: ReactNode;
  children?: MenuItem[];
};

export const menuItems: MenuItem[] = [
  {
    key: getPath('dashboardPage'),
    label: 'Trang chủ',
    code: MENU_ITEM_CODE.HOME,
    icon: <DashboardOutlinedIcon className="!text-lg" />,
  },
  /** Calendar - Lịch cơ quan */
  {
    key: MODULE_KEY.CALENDAR,
    label: 'Lịch cơ quan',
    code: MENU_ITEM_CODE.CALENDAR,
    icon: <CalendarMonthIcon className="!text-lg" />,
    children: [
      {
        key: getPath('workSchedulePage', WORK_SCHEDULE_URL.WORK_SCHEDULE),
        label: renderSidebarLabel('Lịch cơ quan'),
        code: MENU_ITEM_CODE.MENU_WORK_SCHEDULE,
      },
      {
        key: getPath('workSchedulePermissionPage'),
        label: renderSidebarLabel('Quản trị quyền'),
        code: MENU_ITEM_CODE.PERMISSION_WORK_SCHEDULE,
      },
    ],
  },
  /** Document - Văn bản */
  {
    key: MODULE_KEY.DOCUMENT,
    label: 'Văn bản',
    icon: <DescriptionOutlinedIcon className="!text-lg" />,
    code: MENU_ITEM_CODE.DOCUMENT,
    children: [
      {
        key: getPath(
          'internalDocumentsListPage',
          INTERNAL_DOCUMENT_TYPE.INCOMING
        ),
        label: renderSidebarLabel('Văn bản nội bộ'),
        code: MENU_ITEM_CODE.MENU_CHILD_DOCUMENT,
      },
      {
        key: uuid(),
        label: renderSidebarLabel('Liên thông văn bản VIMC'),
        code: MENU_ITEM_CODE.MENU_LIEN_THONG_DOCUMENT,
      },
      // {
      //   key: uuid(),
      //   label: renderSidebarLabel('Liên thông văn bản UBQLV'),
      //   code: MENU_ITEM_CODE.MENU_UBQLV_DOCUMENT,
      // },
      {
        key: uuid(),
        label: renderSidebarLabel('Quản trị'),
        code: MENU_ITEM_CODE.MENU_ADMIN_DOCUMENT,
      },
      {
        key: getPath('documentMangagementPermission'),
        label: renderSidebarLabel('Quản trị quyền'),
        code: MENU_ITEM_CODE.MENU_PERMISSION_DOCUMENT,
      },
    ],
  },
  /** Mission - Nhiệm vụ */
  {
    key: MODULE_KEY.MISSION,
    label: 'Nhiệm vụ',
    icon: <AssignmentOutlinedIcon className="!text-lg" />,
    code: MENU_ITEM_CODE.MISSION,
    children: [
      {
        key: uuid(),
        label: renderSidebarLabel('Nhiệm vụ'),
        code: MENU_ITEM_CODE.MENU_MISSION,
      },
      {
        key: uuid(),
        label: renderSidebarLabel('Lãnh đạo'),
        code: MENU_ITEM_CODE.LANH_DAO_MISSION,
      },
      {
        key: getPath('missionManagementPermission'),
        label: renderSidebarLabel('Quản trị quyền'),
        code: MENU_ITEM_CODE.PERMISSION_MISSION,
      },
    ],
  },
  /** Work - Công việc */
  {
    key: MODULE_KEY.WORK,
    label: 'Công việc',
    icon: <WorkOutlineOutlinedIcon className="!text-lg" />,
    code: MENU_ITEM_CODE.WORK,
    children: [
      {
        key: getPath('workListPage', WORK_TYPE.ALL),
        label: renderSidebarLabel('Công việc'),
        code: MENU_ITEM_CODE.MENU_WORK,
      },
      {
        key: uuid(),
        label: renderSidebarLabel('Quy trình mua sắm'),
        code: MENU_ITEM_CODE.MENU_QUY_TRINH_MUA_SAM,
      },
      {
        key: uuid(),
        label: renderSidebarLabel('Quản trị quyền'),
        code: MENU_ITEM_CODE.PERMISSION_WORK,
      },
    ],
  },
  /** Salary - Bảng lương */
  {
    key: MODULE_KEY.SALARY,
    label: 'Bảng lương',
    icon: <AccountBalanceWalletOutlinedIcon className="!text-lg" />,
    code: MENU_ITEM_CODE.SALARY,
    children: [
      {
        key: uuid(),
        label: renderSidebarLabel('Duyệt lương'),
        code: MENU_ITEM_CODE.MENU_SALARY,
      },
      {
        key: uuid(),
        label: renderSidebarLabel('Lương của tôi'),
        code: MENU_ITEM_CODE.MENU_MY_SALARY,
      },
      {
        key: getPath('salaryManageMentPermission'),
        label: renderSidebarLabel('Quản trị quyền'),
        code: MENU_ITEM_CODE.PERMISSION_SALARY,
      },
    ],
  },
  /** Proposal - Hành chính */
  {
    key: MODULE_KEY.PROPOSAL,
    label: 'Hành chính',
    icon: <ReceiptLongOutlinedIcon className="!text-lg" />,
    code: MENU_ITEM_CODE.PROPOSAL,
    children: [
      {
        key: uuid(),
        label: renderSidebarLabel('Hành chính'),
        code: MENU_ITEM_CODE.MENU_PROPOSAL,
      },
      {
        key: uuid(),
        label: renderSidebarLabel('Phiếu phân phát VPP'),
        code: MENU_ITEM_CODE.MENU_PHAN_PHAT,
      },
      {
        key: uuid(),
        label: renderSidebarLabel('Quản lý kho'),
        code: MENU_ITEM_CODE.SUB_MENU_QUAN_LY_KHO,
      },
      {
        key: uuid(),
        label: renderSidebarLabel('Tạm ứng'),
        code: MENU_ITEM_CODE.MENU_PROPOSAL_ADVANCE,
      },
      {
        key: uuid(),
        label: renderSidebarLabel('Quản trị'),
        code: MENU_ITEM_CODE.ADMINISTRATION_PROPOSAL,
      },
      {
        key: getPath('proposalManagementPermission'),
        label: renderSidebarLabel('Quản trị quyền'),
        code: MENU_ITEM_CODE.PERMISSION_PROPOSAL,
      },
    ],
  },
  /** Risk - Kiểm soát rủi ro */
  {
    key: MODULE_KEY.RISK,
    label: 'Phiếu kiểm soát rủi ro',
    icon: <FileCopyOutlinedIcon className="!text-lg" />,
    code: MENU_ITEM_CODE.RISK,
    children: [
      {
        key: uuid(),
        label: renderSidebarLabel('Phiếu kiểm soát rủi ro'),
        code: MENU_ITEM_CODE.MENU_PKS_RUI_RO,
      },
      {
        key: uuid(),
        label: renderSidebarLabel('Chế độ báo cáo'),
        code: MENU_ITEM_CODE.BAOCAO_PKS_RUI_RO,
      },
      {
        key: uuid(),
        label: renderSidebarLabel('Quản trị loại rủi ro'),
        code: MENU_ITEM_CODE.QUANTRI_PKS_RUI_RO,
      },
      {
        key: getPath('riskManagementPermission'),
        label: renderSidebarLabel('Quản trị quyền'),
        code: MENU_ITEM_CODE.PERMISSION_PKS_RUI_RO,
      },
    ],
  },
  /** Utility - Tiện ích */
  {
    key: MODULE_KEY.UTILITY,
    label: 'Tiện ích',
    icon: <AutoFixHighOutlinedIcon className="!text-lg" />,
    code: MENU_ITEM_CODE.UTILITY,
    children: [
      {
        key: getPath('contactPage'),
        label: renderSidebarLabel('Danh bạ'),
        code: MENU_ITEM_CODE.MENU_DANH_BA,
      },
      {
        key: uuid(),
        label: renderSidebarLabel('Thông báo chung'),
        code: MENU_ITEM_CODE.MENU_NEWS,
      },
      {
        key: uuid(),
        label: renderSidebarLabel('Tài liệu ISO'),
        code: MENU_ITEM_CODE.MENU_ISO,
      },
      {
        key: uuid(),
        label: renderSidebarLabel('Văn bản pháp chế'),
        code: MENU_ITEM_CODE.MENU_PHAP_CHE,
      },
      {
        key: uuid(),
        label: renderSidebarLabel('Ký số điện tử'),
        code: MENU_ITEM_CODE.MENU_KY_SO,
      },
      {
        key: uuid(),
        label: renderSidebarLabel('Tin nhắn liên thông'),
        code: MENU_ITEM_CODE.MENU_TIN_NHAN_LIEN_THONG,
      },
      {
        key: uuid(),
        label: renderSidebarLabel('Tin nhắn nội bộ'),
        code: MENU_ITEM_CODE.MENU_TIN_NHAN_NOI_BO,
      },
      {
        key: uuid(),
        label: renderSidebarLabel('KPI'),
        code: MENU_ITEM_CODE.MENU_KPI,
      },
      {
        key: getPath('ultilityManagementPermission'),
        label: renderSidebarLabel('Quản trị quyền'),
        code: MENU_ITEM_CODE.PERMISSION_UTILITY,
      },
    ],
  },
  /** Report - Báo cáo */
  {
    key: getPath('reportPage'),
    label: 'Báo cáo',
    icon: <StackedBarChartOutlinedIcon className="!text-lg" />,
    code: MENU_ITEM_CODE.REPORT,
  },
  /** Admin System - Quản trị hệ thống */
  {
    key: MODULE_KEY.ADMIN_SYSTEM,
    label: 'Quản trị hệ thống',
    icon: <TuneOutlinedIcon className="!text-lg" />,
    code: MENU_ITEM_CODE.ADMIN_SYSTEM,
    children: [
      {
        key: uuid(),
        label: renderSidebarLabel('Danh mục hệ thống'),
        code: MENU_ITEM_CODE.MENU_CATEGORY_ADMIN_SYSTEM,
      },
      {
        key: getPath('accountManagementPage'),
        label: renderSidebarLabel('Tài khoản'),
        code: MENU_ITEM_CODE.ACCOUNT_ADMIN_SYSTEM,
      },
      {
        key: getPath('managementPermission'),
        label: renderSidebarLabel('Quản trị quyền'),
        code: MENU_ITEM_CODE.PERMISSION_ADMIN_SYSTEM,
      },
    ],
  },
];
